import dataCache from './dataCache'
import createImgByVideo from './createImgByVideo'
import print from './print'
import md5 from 'js-md5';
import drawImage from './drawImage';
import constant from './constant';
import business from './business';

export default {
  md5,
  ...constant, //常量
  ...dataCache,
  ...createImgByVideo,
  ...print,
  ...drawImage,
  ...business, //业务常用处理方法
  cos: {
    bucket: "jarvis-1302225989",
    region: "ap-chongqing",
  },
  JSONToString(data) {
    let keys = Object.keys(data);
    let rtn = '';
    keys.map(item => {
      rtn += item + '=' + data[item] + '&';
    });
    rtn = rtn.substr(0, rtn.length - 1);
    return rtn;
  },
  stringToJSON(data) {
    if (typeof (data) == 'object') {
      return data;
    }
    let searchArr = data.replace('?', '').split('&');
    let params = {};
    searchArr.map(paramtxt => {
      let param = paramtxt.split('=');
      if (param.length == 2)
        params[param[0]] = decodeURIComponent(param[1]);
    })
    return params;
  },
  reg: {
    email: '^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$',
    phone: /^1\d{10}$/,
    ip: /^((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}$/,
    fax: /^(?:\d{3,4}-)?\d{7,8}(?:-\d{1,6})?$/,
    wechat: /^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/,//微信号验证
    discount: /^1$|^-?(0\.\d{1,4})?$/,//0.0001到1范围折扣/^-?(0\.\d*[1-9]+\d*)$/
    thanNum: /^\d+(\.{0,1}\d+){0,1}$/,//非负数
  },
  downloadFile(url, name) {
    var link = document.createElement('a');
    link.setAttribute("download", name);
    link.href = url;
    link.click();
  },
  deepClone(source) {
    const targetObj = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
    for (let keys in source) { // 遍历目标
      if (source.hasOwnProperty(keys)) {
        if (source[keys] && typeof source[keys] === 'object') { // 如果值是对象，就递归一下
          targetObj[keys] = source[keys].constructor === Array ? [] : {};
          targetObj[keys] = this.deepClone(source[keys]);
        } else { // 如果不是，就直接赋值
          targetObj[keys] = source[keys];
        }
      }
    }
    return targetObj;
  },
  getTop(e) {
    var offset = e.offsetTop;
    if (e.offsetParent != null) offset += this.getTop(e.offsetParent);
    return offset;
  },
  returnFloat(data1, data2) {
    var value = '';
    if (typeof (data1) == 'number' || typeof (data1) == 'string')
      value = Math.round(parseFloat(data1) * 100) / 100;
    else if (data1 && data2)
      value = Math.round(parseFloat(data1[data2.prop]) * 100) / 100;
    var xsd = value.toString().split(".");
    if (xsd.length == 1) {
      value = value.toString() + ".00";
      return value;
    }
    if (xsd.length > 1) {
      if (xsd[1].length < 2) {
        value = value.toString() + "0";
      }
      return value;
    }
  },
  //上传单个文件
  uploadFile(callback, data) {
    var fileDom = document.createElement('input');
    fileDom.setAttribute("type", 'file');
    fileDom.addEventListener('change', function () {
      callback && callback(this.files[0], data);
    });
    fileDom.click();
  },
  stringToBytes(str) {
    var ch, st, re = [];
    for (var i = 0; i < str.length; i++) {
      ch = str.charCodeAt(i); // get char
      st = []; // set up "stack"

      do {
        st.push(ch & 0xFF); // push byte to stack
        ch = ch >> 8; // shift value down by 1 byte
      }
      while (ch);
      // add stack contents to result
      // done because chars have "wrong" endianness
      re = re.concat(st.reverse());
    }
    // return an array of bytes
    return re;
  },
  sortASCII(obj) {
    var arr = new Array();
    var num = 0;
    for (var i in obj) {
      arr[num] = i;
      num++;
    }
    var sortArr = arr.sort();
    var sortObj = {};
    for (var i in sortArr) {
      sortObj[sortArr[i]] = obj[sortArr[i]];
    }
    return sortObj;
  },
  base64(s) {
    return window.btoa(unescape(encodeURIComponent(s)))
  },
  tableToExcel(htmlData, excelName) {
    var excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
    excelFile += "<head><meta charset='UTF-8'><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>";
    excelFile += "<body><table>";
    excelFile += htmlData;
    excelFile += "</table></body>";
    excelFile += "</html>";
    var link = "data:application/vnd.ms-excel;base64," + this.base64(excelFile);
    var a = document.createElement("a");
    a.download = excelName + ".xls";
    a.href = link;
    a.click();
  },

  getDateTime() {
    var date = new Date();
    var year = date.getFullYear(),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      sdate = ("0" + date.getDate()).slice(-2),
      hour = ("0" + date.getHours()).slice(-2),
      minute = ("0" + date.getMinutes()).slice(-2),
      second = ("0" + date.getSeconds()).slice(-2);
    // 返回
    return year + month + sdate + hour + minute + second;
  }

}



// WEBPACK FOOTER //
// ./src/utils/index.js